export default "__VITE_ASSET__DMnDZ94h__"